import React from "react";
import StudentLeftside from "./StudentLeftside";
import AnnouncementList from "../components/AnnouncementList";

const Announcement = () => {
  return (
    <div className="dashboard-wrap bg-light">
      <StudentLeftside />

      <main
        className="dashboard-content container py-4"
        style={{ marginTop: "100px" }}
      >
        <h3 className="fw-bold mb-4 text-start">
          Announcements
        </h3>

         
        <AnnouncementList />

      </main>
    </div>
  );
};

export default Announcement;